import session_wechat from './session/wechat'

export default function parseWechatLogin() {
  if (window._jsOAuthResult) {
    let wechatObj = new session_wechat({
      appid: _jsOAuthResult.appid,
      openid: _jsOAuthResult.openid,
      accessToken: _jsOAuthResult.access_token
    });

    wechatObj.userinfo = _jsOAuthResult.userinfo;
    return wechatObj;
  }
  return null;
}